import fetchPonyfill from 'fetch-ponyfill';
import {defaultLanguage} from 'locale';
import {searchFromConfig} from 'store/search/actions';
import {toggleWordHighlight} from 'store/config/actions';

export const {fetch} = fetchPonyfill();

export const ActionTypes = {
    LOAD_ELEMENT_LIST_MANIFEST: 'LOAD_ELEMENT_LIST_MANIFEST',
    ELEMENT_LIST_MANIFEST_LOADED: 'ELEMENT_LIST_MANIFEST_LOADED',
    ELEMENT_LIST_MANIFEST_FAILED: 'ELEMENT_LIST_MANIFEST_FAILED',
    PARSE_ELEMENT_LIST_MANIFEST: 'PARSE_ELEMENT_LIST_MANIFEST',
    LOAD_ELEMENT_LIST: 'LOAD_ELEMENT_LIST',
    ELEMENT_LIST_LOADED: 'ELEMENT_LIST_LOADED',
    ELEMENT_LIST_FAILED: 'ELEMENT_LIST_FAILED',
    PARSE_ELEMENT_LIST: 'PARSE_ELEMENT_LIST',
    SET_ELEMENT_LIST_FROM_CACHE: 'SET_ELEMENT_LIST_FROM_CACHE',
};

export const loadingManifest = () => ({
    type: ActionTypes.LOAD_ELEMENT_LIST_MANIFEST,
});

export const manifestLoaded = () => ({
    type: ActionTypes.ELEMENT_LIST_MANIFEST_LOADED,
});

export const manifestFailed = () => ({
    type: ActionTypes.ELEMENT_LIST_MANIFEST_FAILED,
});

export const parseManifest = (urls) => ({
    type: ActionTypes.PARSE_ELEMENT_LIST_MANIFEST,
    urls,
});

export const loadMDPS1Manifest = async (config) => {
    const shortCode = config.get('shortCode');
    const response = await exports.fetch(`${VWRAP.mdps1}/manifest/${shortCode}?v=1`);
    if (response.ok) {
        const {languages} = await response.json();
        return languages.reduce((urls, language) => {
            urls[language] = {href: `${VWRAP.mdps1}/el/${shortCode}?v=1&lang=${language}`};
            return urls;
        }, {});
    }
    throw new Error('Error loading manifest from MDPS V1');
};

export const loadMDPS3Manifest = async (config) => {
    const response = await exports.fetch(`${VWRAP.mdps3}/GetMDPSEntry?job_id=${config.get('jobId')}`);
    if (response.ok) {
        const manifest = await response.json();
        return manifest.reduce((urls, {language, url}) => {
            urls[language] = {href: url};
            return urls;
        }, {});
    }
    throw new Error('Error loading manifest from MDPS V3');
};

export const loadManifest = () => async (dispatch, getState) => {
    const {config} = getState();

    try {
        dispatch(loadingManifest());
        let manifest = config.get('elementListManifest');

        if (!manifest) {
            const mdpsVersion = Number(config.get('mdpsVersion'));
            if (mdpsVersion === 1) manifest = await loadMDPS1Manifest(config);
            else if (mdpsVersion === 3) manifest = await loadMDPS3Manifest(config);
            else throw new Error('Invalid configuration');
        }

        dispatch(parseManifest(manifest));
        dispatch(manifestLoaded());

        return manifest;
    } catch (error) {
        dispatch(manifestFailed());
        console.error(error); // eslint-disable-line no-console
        throw new Error('Manifest failed to load');
    }
};

export const loadingElementList = () => ({
    type: ActionTypes.LOAD_ELEMENT_LIST,
});

export const elementListLoaded = () => ({
    type: ActionTypes.ELEMENT_LIST_LOADED,
});

export const elementListFailed = () => ({
    type: ActionTypes.ELEMENT_LIST_FAILED,
});

export const parseElementList = (elementList, videoDuration, language) => ({
    type: ActionTypes.PARSE_ELEMENT_LIST,
    language,
    elementList,
    videoDuration,
});

export const setElementListFromCache = (language) => ({
    type: ActionTypes.SET_ELEMENT_LIST_FROM_CACHE,
    language,
});

const getAvailableLanguages = state => [...state.elementList.get('urls').keys()];

export const loadElementList = () => async (dispatch, getState) => {
    const state = getState();

    let targetLanguage = state.config.get('language');
    const availableLanguages = getAvailableLanguages(state);
    if (!availableLanguages.includes(targetLanguage)) {
        if (availableLanguages.includes(defaultLanguage)) targetLanguage = defaultLanguage;
        else targetLanguage = availableLanguages[0];
    }

    const cache = state.elementList.get('cache');
    if (cache.has(targetLanguage)) {
        dispatch(setElementListFromCache(targetLanguage));
        dispatch(searchFromConfig());
        return;
    }

    const url = state.elementList.getIn(['urls', targetLanguage, 'href']);
    try {
        dispatch(loadingElementList());
        const response = await exports.fetch(url);
        if (response.ok) {
            const elementList = await response.json();
            const videoDuration = state.video.get('duration');

            // Enforce word-highlighting if we're dealing with just one sentence
            if (elementList.segments && elementList.segments.length === 1) dispatch(toggleWordHighlight(true));

            dispatch(parseElementList(elementList, videoDuration, targetLanguage));
            dispatch(elementListLoaded());
            dispatch(searchFromConfig());
            return elementList;
        }
    } catch (error) {
        dispatch(elementListFailed());
        console.error(error); // eslint-disable-line no-console
        throw new Error(`ElementList failed to load (${url})`);
    }
};



// WEBPACK FOOTER //
// ./scripts/store/element-list/actions.js